import { IFilterItem } from "..";
import { IAuction, ICorridorDetail } from "../../services";
import {
  AuctionActionEnum,
  IFetchAuctionDataOnlyAction,
  IFetchedAuctionDataOnlyFailedAction,
  IFetchedAuctionDataOnlySuccessAction,
  IFetchedAuctionDataOnlyWithoutDateAction,
  IFetchedFiltersAndAuctionDataFailedAction,
  IFetchedFiltersAndAuctionDataSuccessAction,
  IFetchFiltersAndAuctionAction,
  IUpateAuctionBidStatusFilterValueAction,
  IUpdateAuctionCorridorFilterValueAction,
  IUpdateAuctionExchangeFilterValueAction,
  IUpdateAuctionInterconnectorFilterValueAction,
  IUpdateAuctionIsShowFilterValueAction,
  IUpdateAuctionProductFilterValueAction,
  IUpdateAuctionWithBidResultsAction,
} from "./";

export const FetchFiltersAndAuctionDataAction = (date: Date) => {
  return {
    type: AuctionActionEnum.FetchFiltersAndAuctionData,
    state: { loading: true, initialFilters: { startDateUtc: date } },
  } as IFetchFiltersAndAuctionAction;
};
export const UpdateAuctionWithBidResultAuction = (data: IAuction[]) => {
  return {
    type: AuctionActionEnum.UpdateAuctionWithBidResultAction,
    state: { data },
  } as IUpdateAuctionWithBidResultsAction;
};

export const FetchedFiltersAndAuctionDataSuccessAction = (
  data: IAuction[],
  co: ICorridorDetail[]
) => {
  let con = co
    .map((x) => x.corridor)
    .filter((v, i, a) => {
      return v && a.indexOf(v) === i;
    })
    .map((item) => {
      return { value: item, isSelected: true } as IFilterItem;
    });
  let ic = co
    .map((x) => x.interconnector)
    .filter(
      (v, i, a) =>
        v?.toLowerCase() !== "N/A".toLowerCase() && v && a.indexOf(v) === i
    )
    .map((item) => {
      return { value: item, isSelected: true } as IFilterItem;
    });
  let exchanges = data
    .map((x) => x.exchangeCode)
    .filter((v, i, a) => a.indexOf(v) === i)
    .map((item) => {
      return { value: item, isSelected: true } as IFilterItem;
    });
  return {
    type: AuctionActionEnum.FetchedFiltersAndAuctionDataSuccess,
    state: {
      data,
      loading: false,
      initialFilters: {
        corridorKeys: co.map((x) => x.corridorKey),
        corridors: con,
        interconnectors: ic,
        exchanges: exchanges,
      },
    },
  } as IFetchedFiltersAndAuctionDataSuccessAction;
};

export const FetchedFiltersAndAuctionDataFailedAction = (message: string) => {
  return {
    type: AuctionActionEnum.FetchedFiltersAndAuctionDataFailed,
    state: { loading: false, exceptionMessage: message },
  } as IFetchedFiltersAndAuctionDataFailedAction;
};

export const UpateAuctionCorridorFilterValueAction = (
  currentCorridors: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(currentCorridors, updateValue);

  return {
    type: AuctionActionEnum.UpdateAuctionCorridorFilterValue,
    state: { currentFilters: { corridors: filtersWithAllCheck } },
  } as IUpdateAuctionCorridorFilterValueAction;
};

export const UpateAuctionProductFilterValueAction = (
  product: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(product, updateValue);
  return {
    type: AuctionActionEnum.UpateAuctionProductFilterValue,
    state: {
      currentFilters: { products: filtersWithAllCheck },
    },
  } as IUpdateAuctionProductFilterValueAction;
};

export const UpateAuctionBidStatusFilterValueAction = (
  product: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(product, updateValue);
  return {
    type: AuctionActionEnum.UpateAuctionBidStatusFilterValue,
    state: {
      currentFilters: { bidStatus: filtersWithAllCheck },
    },
  } as IUpateAuctionBidStatusFilterValueAction;
};

export const UpateAuctionIsShowFilterValueAction = (isShow: boolean) => {
  return {
    type: AuctionActionEnum.UpateAuctionIsShowFilterValue,
    state: {
      currentFilters: { isShow },
    },
  } as IUpdateAuctionIsShowFilterValueAction;
};

export const UpateAuctionInterconnectorFilterValueAction = (
  interconnectors: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(interconnectors, updateValue);

  return {
    type: AuctionActionEnum.UpateAuctionInterconnectorFilterValue,
    state: {
      currentFilters: { interconnectors: filtersWithAllCheck },
    },
  } as IUpdateAuctionInterconnectorFilterValueAction;
};

export const UpdateAuctionExchangeFilterValueAction = (
  exchanges: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(exchanges, updateValue);
  return {
    type: AuctionActionEnum.UpdateAuctionExchangeFilterValue,
    state: {
      currentFilters: { exchanges: filtersWithAllCheck },
    },
  } as IUpdateAuctionExchangeFilterValueAction;
};

export const FetchAuctionDataOnlyAction = (date: Date) => {
  return {
    type: AuctionActionEnum.FetchAuctionDataOnlyAction,
    state: { loading: true, currentFilters: { startDateUtc: date } },
  } as IFetchAuctionDataOnlyAction;
};

export const FetchAuctionDataOnlyWithDateAction = (auction: IAuction[]) => {
  return {
    type: AuctionActionEnum.FetchAuctionDataOnlyWithoutDateAction,
    state: { data: auction },
  } as IFetchedAuctionDataOnlyWithoutDateAction;
};

export const FetchedAuctionDataOnlySuccessAction = (data: IAuction[]) => {
  return {
    type: AuctionActionEnum.FetchedAuctionDataOnlySuccess,
    state: { data, loading: false },
  } as IFetchedAuctionDataOnlySuccessAction;
};

export const FetchAuctionDataOnlyFailureAction = (message: string) => {
  return {
    type: AuctionActionEnum.FetchedAuctionDataOnlyFailed,
    state: { loading: false, exceptionMessage: message },
  } as IFetchedAuctionDataOnlyFailedAction;
};

const tryAssignAll = (
  filters: IFilterItem[],
  selectedFilterItem: IFilterItem
): IFilterItem[] => {
  return filters?.map((x) => {
    if (selectedFilterItem.value.toLowerCase() === "All".toLowerCase()) {
      x.isSelected = selectedFilterItem.isSelected;
    }

    if (x.value === selectedFilterItem.value) {
      return selectedFilterItem;
    }
    return x;
  });
};
